<template>
    <div class="mx-auto">
        <b-card>
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <CompBotaoExibirOcultarColuna
                            :fields="fields"
                            :showColunms="showColunms"
                            :texto-botao="'Colunas'"
                            @toggleColuna="toggleColuna"/>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                                   class="mb-3 col-2" style="float:right"></b-form-select>
                    <b-button class="ml-2" variant="secondary" @click="limparFiltros"
                              style="float: right; margin-right: 10px; height: 32px; padding: 0 0.75rem;">
                        <i class="fa fa-eraser"></i> Limpar Filtros
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <label>
                        Arquivos: <strong>{{ configTable.rows }}</strong> / Selecionadas: <strong>{{ selecteds.length }}</strong>
                    </label>
                </b-col>
            </b-row>

            <b-table
                    id="arquivos"
                    :items="resultado"
                    :fields="fields"
                    striped
                    small
                    responsive="sm"
                    :no-local-sorting="true"
                    :busy="configTable.load"
                    show-empty>
                <div slot="table-busy" class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Carregando...</strong>
                </div>
                <template slot="empty">
                    <p class="my-auto">Nenhuma CDA encontrada.</p>
                </template>
                <template slot="HEAD_selecionar">
                    <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
                </template>
                <template slot="selecionar" slot-scope="row">
                    <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(row.item)" @change="toggleCheck($event, row.item)" />
                </template>

                <template slot="HEAD_1">
                    Data de Recebimento <i class="filter" :class="!isEmpty(filtros.dataRecebimento) || filtros.filtrarDataRecebimento == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data de Recebimento', 'data', '', null, $event)"></i>
                </template>
                <template slot="1" slot-scope="row">
                    <p class="text-center">
                        {{ row.item.dataRecebimento }}
                    </p>
                </template>
                <template slot="HEAD_2">
                    Nome do Arquivo <i class="filter" :class="!isEmpty(filtros.nomeArquivo) || filtros.filtrarNomeArquivo == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Nome do Arquivo', 'texto', '', null, $event)"></i>
                </template>
                <template slot="2" slot-scope="row">
                    <b-link @click="downloadArquivo(row.item)" class="m-0 p-0">
                        {{ row.item.nomeArquivo }}
                    </b-link>
                </template>
                <template slot="HEAD_3">
                    Status <i class="filter" :class="!isEmpty(filtros.status) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Status', 'checkbox', dados.status, null, $event)"></i>
                </template>
                <template slot="3" slot-scope="row">
                    <p class="m-0 p-0"> {{ row.item.status }} </p>
                </template>
                <template slot="HEAD_4">
                    Erro <i class="filter" :class="!isEmpty(filtros.erro) || filtros.filtrarErro == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Erro', 'texto', '', null, $event)"></i>
                </template>
                <template slot="4" slot-scope="row">
                    <p class="m-0 p-0" style="max-width: 600px"> {{ row.item.erro }} </p>
                </template>
            </b-table>

            <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompBotaoExibirOcultarColuna from "../../shared/components/CompBotaoExibirOcultarColuna";

    export default {
    props: ['resultado', 'configTable', 'filtros', 'selecteds'],
    components: {
        CompBotaoExibirOcultarColuna,
    },
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        },
        perPage() {
            this.configTable.currentPage = 1;
            this.$emit('consultar');
        }
    },
    data() {
        return {
            urlApi: null,
            token: null,
            showColunms: [],
            fields: [
                {
                    key: "selecionar",
                },
            ],
            dados: {
                status: []
            },
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
        perPage() {
            return this.configTable.perPage;
        },
    },
    methods: {
        async obterColunasUsuario() {
            const funcionalidade = 'processamentoArquivo';

            axios.get(`${this.urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                response.data.forEach((field, i) => {
                    if (field.ativo) {
                        this.showColunms.push(i + 1)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.configTable.load = false;
            })
        },

        toggleColuna(i) {
            let ativo;
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1);
                this.fields[i].thClass = 'd-none';
                this.fields[i].tdClass = 'd-none';
                ativo = false
            } else {
                this.showColunms.push(i);
                this.fields[i].thClass = '';
                this.fields[i].tdClass = '';
                ativo = true
            }

            this.atualizarConfiguracaoColunm(i, ativo)
        },

        async atualizarConfiguracaoColunm(i, ativo) {
            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            };
            axios.post(`${this.urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })
        },

        openFilter(campo, tipo, values, mask, event) {
            this.$emit('openFilterPopup', campo, tipo, values, mask, event);
        },
        limparFiltros() {
            this.$emit('limparFiltros');
        },
        async listarStatus() {
            axios.get(`${this.urlApi}/v1/arquivoProcessamento/listarStatus`).then(response => {
                this.dados.status = response.data
            })
        },

        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.selecteds.includes(el)) {
                        this.selecteds.push(el);
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    el.checked = false;
                    if(this.selecteds.includes(el)) {
                        const index = this.selecteds.indexOf(el);
                        this.selecteds.splice(index, 1);
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                item.checked = checked;
                this.selecteds.push(item);
            } else {
                item.checked = checked;
                const index = this.selecteds.indexOf(item);
                this.selecteds.splice(index, 1);
                this.configTable.checkedAll = false;
            }

        },
        async downloadArquivo(item) {
            await axios.post(`${this.urlApi}/v1/arquivoProcessamento/baixarArquivo`, item.caminhoArquivo, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                if(!response.data || !response.data.byteLength){
                    this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                    return;
                }

                let blob = new Blob([response.data], {type: "octet/stream"});
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = item.nomeArquivo;
                link.click();
            }).catch((error) => {
                this.exibirErro(error)
            });
        }
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        this.obterColunasUsuario();

        this.listarStatus();
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
